document.addEventListener('DOMContentLoaded', function() {
//Open all filter dropdowns
  const elements = document.querySelectorAll('div#FacetsWrapperDesktop details.facets__disclosure-vertical.js-filter');
     elements.forEach(element => {
         element.setAttribute('open', '');
     });
    setTimeout(() => {
        const cardInformationDivs = document.querySelectorAll('.card-information');

        cardInformationDivs.forEach(cardInformationDiv => {
            const priceContainer = cardInformationDiv.querySelector('.price__container');

            if (priceContainer) {
                const regularPriceExists = priceContainer.querySelector('.price-item.price-item--regular');
                const salePriceExists = priceContainer.querySelector('.price-item.price-item--sale.price-item--last');

                if (regularPriceExists && salePriceExists) {
                    const affirmParagraph = priceContainer.querySelector('.price__sale .affirm-as-low-as');

                    if (affirmParagraph) {
                        affirmParagraph.remove();

                        const newDiv = document.createElement('div');
                        newDiv.className = 'new-div-for-affirm';
                        newDiv.appendChild(affirmParagraph);

                        cardInformationDiv.appendChild(newDiv);
                    }
                }
            }
        });
    }, 1500);
});